const yup = require('yup');
const _ = require('lodash');
const getOptionValue = require('./optionValue');

function deserializeValue(
  state,
  { isMultiple, options, companionField },
  dependencies,
  { key, values },
) {
  if (isMultiple && !Array.isArray(state.value)) {
    return [state.value];
  } if (!isMultiple && Array.isArray(state.value)) {
    if (state.value.length > 0) return state.value[0];
    return '';
  }

  if (companionField) {
    options.forEach((option) => {
      // eslint-disable-next-line no-param-reassign
      values[`${key}_companion_value_${option.value}`] = state[`companion_value_${option.value}`] ?? '';
    });
  }

  return state.value;
}

module.exports = {
  getDefaultValue: ({ isMultiple }) => (isMultiple ? [] : ''),
  serializeValue: (value, { options, companionField }, dependencies, { key, values }) => {
    const newState = { value };

    if (companionField) {
      options.forEach((option) => {
        const companionFieldValue = values[`${key}_companion_value_${option.value}`];

        if (!companionFieldValue) return;

        newState[`companion_value_${option.value}`] = companionFieldValue.trim();
      });
    }

    const notYetAnsweredOption = options.find((o) => o.isNotYetAnswered);

    // Check, if the option that marks this as 'not answered' was selected
    if (!notYetAnsweredOption) return newState;

    const notYetAnsweredValue = getOptionValue(notYetAnsweredOption);

    if (value === notYetAnsweredValue) {
      newState.hasValue = false;
    }

    return newState;
  },
  deserializeValue,
  getDisplayValue: (...args) => {
    const state = args[0];
    const { options, isOptionsNewLineFunction, showInternalValue } = args[1];
    const value = deserializeValue(...args);
    const delimiter = isOptionsNewLineFunction ? '\n' : '; ';
    const valuePrefix = isOptionsNewLineFunction ? '\u{2022} ' : '';

    if (!value) {
      return '-';
    }

    if (Array.isArray(value)) {
      return value.map((item) => {
        const option = options.find((o) => _.isEqual(getOptionValue(o), item));
        let optionLabel = showInternalValue
          ? (option?.internalLabel ?? option?.label ?? item)
          : (option?.label ?? item);

        if (option && state[`companion_value_${option.value}`]) {
          optionLabel = `${optionLabel} (${state[`companion_value_${option.value}`]})`;
        }

        return valuePrefix + optionLabel;
      }).join(delimiter);
    }

    const selectedOption = options
      .find((option) => _.isEqual(getOptionValue(option), value));

    return showInternalValue
      ? (selectedOption?.internalLabel ?? selectedOption?.label ?? value)
      : (selectedOption?.label ?? value);
  },
  validationSchema: ({
    isMultiple, minOptions, maxOptions, options, companionField,
  }, { key, fieldValidations }) => {
    if (isMultiple) {
      if (companionField) {
        options.forEach((option) => {
          const min = companionField[0]?.minValue ?? 0;
          const max = companionField[0]?.maxValue ?? 1000;

          // eslint-disable-next-line no-param-reassign
          fieldValidations[`${key}_companion_value_${option.value}`] = yup
            .number()
            .min(min, `Wert muss mind. ${min} betragen.`)
            .max(max, `Wert darf max. ${max} betragen.`)
            .nullable();
        });
      }

      const min = minOptions ?? 0;
      const max = maxOptions ?? Number.MAX_SAFE_INTEGER;

      return yup
        .array()
        .of(yup.string())
        .min(min, `Bitte wählen Sie mind. ${min} ${min === 1 ? 'Option' : 'Optionen'} aus.`)
        .max(max, `Bitte wählen Sie max. ${max} ${max === 1 ? 'Option' : 'Optionen'} aus.`);
    }

    return yup.string().nullable();
  },
};
